<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Text, Select } from '@Shelly/shelly-design-system';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

	export let controlOption: LocalControlOptions;
</script>

<div>
	<Text class="mb-s" element="h2">
		{$format('select_target_component', {
			default: 'Select target component:',
		})}
	</Text>
	<Select
		size="m"
		value={controlOption.attr.target.find((i) => i.value == controlOption.params.id) ||
			$format('non_existed_component', {
				default: 'Non-Existed Component',
			})}
		options={controlOption.attr.target}
		disabled={controlOption.attr.target.length <= 1}
		icon={'fal fa-microchip'}
		on:change={(e) => {
			controlOption.params.id = e.detail['value'];
		}}
		id="select-jli8pqj"
		aria-label={$format('select_target_component', {
			default: 'Select target component',
		})}
	/>
</div>
